import { Toaster } from "@/components/ui/toaster";

import { Toaster as Sonner } from "@/components/ui/sonner";

import { TooltipProvider } from "@/components/ui/tooltip";

import { QueryClientProvider } from "@tanstack/react-query";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import { queryClient } from "@/lib/query-client";

import { AuthProvider } from "@/contexts/AuthContext";

import { LanguageProvider } from "@/contexts/LanguageContext";

import ProtectedRoute from "@/middleware/ProtectedRoute";

import PublicRoute from "@/middleware/PublicRoute";

import PublicLayout from "./components/layout/PublicLayout";

import DashboardLayout from "./components/layout/DashboardLayout";

import {

  Home,

  About,

  Tenders,

  HowItWorks,

  Portfolio,

  Contact,

  Auth,

  Privacy,

  Terms,

  NotFound,

  ClientDashboard,

  Profile,

  ClientPortfolio,

  PublicProjectDetails,

  ProjectDetails,

  AddEditProject,

  ClientTenders,

  TenderDetails,

  SubmitOffer,

  Applications,


  AdminDashboard,

  AdminClients,

  CreateClient,

  EditClient,

  AdminClientDetails,

  AdminTenders,

  AdminTenderDetails,

  AdminOfferDetails,

  AdminContentManagement,

  AdminSpecializations,

  AdminSettings,

  AdminOffers,

  AdminProfile,

  AdminCompanyProjects,

  AdminClientProjects,

  AdminUsers,

} from "./pages";



const App = () => (

  <QueryClientProvider client={queryClient}>

    <LanguageProvider>

      <AuthProvider>

        <TooltipProvider>

          <Toaster />

          <Sonner />

          <BrowserRouter

            future={{

              v7_startTransition: true,

              v7_relativeSplatPath: true,

            }}

          >

            <Routes>

              {/* Public Routes */}

              <Route element={<PublicLayout />}>

                <Route path="/" element={<Home />} />

                <Route path="/about" element={<About />} />

                <Route path="/tenders" element={<Tenders />} />

                <Route path="/how-it-works" element={<HowItWorks />} />

                <Route path="/portfolio" element={<Portfolio />} />

                <Route path="/portfolio/:id" element={<PublicProjectDetails />} />

                <Route path="/contact" element={<Contact />} />

                <Route path="/privacy" element={<Privacy />} />

                <Route path="/terms" element={<Terms />} />

              </Route>

              

              {/* Auth Routes */}

              <Route 

                path="/auth" 

                element={

                  <PublicRoute>

                    <Auth />

                  </PublicRoute>

                } 

              />

              

              {/* Client Dashboard Routes */}

              <Route 

                path="/dashboard" 

                element={

                  <ProtectedRoute requiredRole="client">

                    <DashboardLayout />

                  </ProtectedRoute>

                }

              >

                <Route index element={<ClientDashboard />} />

                <Route path="profile" element={<Profile />} />

                <Route path="portfolio" element={<ClientPortfolio />} />

                <Route path="portfolio/new" element={<AddEditProject />} />

                <Route path="portfolio/:id" element={<ProjectDetails />} />

                <Route path="portfolio/:id/edit" element={<AddEditProject />} />

                <Route path="tenders" element={<ClientTenders />} />

                <Route path="tenders/:id" element={<TenderDetails />} />

                <Route path="tenders/:id/offer" element={<SubmitOffer />} />

                <Route path="applications" element={<Applications />} />


              </Route>

              

              {/* Admin Dashboard Routes */}

              <Route 

                path="/admin/dashboard" 

                element={

                  <ProtectedRoute requiredRole="admin">

                    <DashboardLayout />

                  </ProtectedRoute>

                }

              >

                <Route index element={<AdminDashboard />} />

                <Route path="profile" element={<AdminProfile />} />

                <Route path="clients" element={<AdminClients />} />

                <Route path="clients/create" element={<CreateClient />} />

                <Route path="clients/:id/edit" element={<EditClient />} />

                <Route path="clients/:id" element={<AdminClientDetails />} />

                <Route path="tenders" element={<AdminTenders />} />

                <Route path="tenders/:id" element={<AdminTenderDetails />} />

                <Route path="tenders/:id/edit" element={<AdminTenders />} />

                <Route path="offers" element={<AdminOffers />} />

                <Route path="offers/:id" element={<AdminOfferDetails />} />

                <Route path="content" element={<AdminContentManagement />} />

                <Route path="specializations" element={<AdminSpecializations />} />

                <Route path="settings" element={<AdminSettings />} />

                <Route path="company-projects" element={<AdminCompanyProjects />} />

                <Route path="client-projects" element={<AdminClientProjects />} />

                <Route path="admins" element={<AdminUsers />} />

              </Route>

              

              <Route path="*" element={<NotFound />} />

            </Routes>

          </BrowserRouter>

        </TooltipProvider>

      </AuthProvider>

    </LanguageProvider>

  </QueryClientProvider>

);



export default App;

